
export default {
  name: 'features',
  data: () => ({
    feature: {}
  }),
  methods: {
    cancel_feature() {
      for (const name in this.computed_feature) {
        this.feature[name] = this.computed_feature[name]
      }
    },
    async save_feature() {
      this.$store.commit('feature', JSON.parse(JSON.stringify(this.feature)))
      await this.$communicator('update_features', {
        params: this.feature
      })
      this.loading_settings_feature = false;
      this.update_feature()
      // this.$store.commit('lang', this.lang)
    },
    async update_feature() {
      const feature = this.$communicator.then(this, await this.$communicator('features'))
      if (feature) {
        this.$store.commit('feature', feature)
        this.feature = this.$copy(feature)
      }
      else this.feature = JSON.parse(JSON.stringify(this.computed_feature))
    }
  },
  computed: {
    features() { return this.$store.state.features },
    computed_feature() { return this.$store.state.feature }
  },
  mounted() {
    this.update_feature()
  }
}
